import { Link } from "react-router-dom";
import "./Logout.css";

function Logout() {
  return (
    <div className="logout-page">

      <div className="logout-card">

        <div className="logout-icon">
          👋
        </div>

        <h1>Successfully Logged Out</h1>

        <p>
          You have been securely logged out of CODEION.
          Continue your learning journey anytime.
        </p>

        <Link to="/auth" className="logout-btn">
          Login Again
        </Link>

        <Link to="/" className="logout-home">
          Back to Home
        </Link>

      </div>

    </div>
  );
}

export default Logout;